import type {
	CollectionHit,
	FacetHit,
	PlaylistHit,
	QueryHit,
} from '@/utils/algolia/autocompleteHitTypes'

import { CollectionOption } from './collections/CollectionOptionComponent'
import { EmptyStateOption } from './empty-state/EmptyStateOptionComponent'
import { EmptyStateOptionProps } from './empty-state/EmptyStatePlugin.types'
import { FacetOption } from './facets/FacetOptionComponent'
import { PlaylistOption } from './playlists/PlaylistOptionComponent'
import { SuggestionsAndPromptOption } from './suggestions-and-prompt/SuggestionsAndPromptOptionComponent'

// plugins
export { collectionsPlugin } from './collections/CollectionPlugin'
export { emptyStatePlugin } from './empty-state/EmptyStatePlugin'
export { facetsPlugin } from './facets/FacetPlugin'
export { playlistsPlugin } from './playlists/PlaylistPlugin'
export { suggestionsAndPromptPlugin } from './suggestions-and-prompt/SuggestionsAndPromptPlugin'
export type {
	AlgoliaCollection,
	AlgoliaPlaylist,
	CollectionHit,
	FacetHit,
	PlaylistHit,
	QueryHit,
} from '@/utils/algolia/autocompleteHitTypes'

export type PluginHit = PlaylistHit | CollectionHit | FacetHit | QueryHit

export const OPTION_COMPONENTS = {
	emptyStateSource: ({ onClose }: EmptyStateOptionProps) => (
		<EmptyStateOption onClose={onClose} />
	),
	suggestionsAndPromptSource: ({
		item,
		hasSuggestions,
		activeItemId,
	}: {
		item: PluginHit
		hasSuggestions: boolean
		activeItemId: number
	}) => (
		<SuggestionsAndPromptOption
			item={item as QueryHit}
			hasSuggestions={hasSuggestions}
			activeItemId={activeItemId}
		/>
	),
	facetsSource: ({
		item,
		activeItemId,
	}: {
		item: PluginHit
		activeItemId: number
	}) => <FacetOption item={item as FacetHit} activeItemId={activeItemId} />,
	playlistsSource: ({
		item,
		activeItemId,
	}: {
		item: PluginHit
		activeItemId: number
	}) => (
		<PlaylistOption item={item as PlaylistHit} activeItemId={activeItemId} />
	),
	collectionsSource: ({
		item,
		activeItemId,
	}: {
		item: PluginHit
		activeItemId: number
	}) => (
		<CollectionOption
			item={item as CollectionHit}
			activeItemId={activeItemId}
		/>
	),
}
